import pb from "../../lib/pocketbase";
import Container from "../../components/Container";
import React, { useEffect, useState } from "react";
import ConfettiExplosion from "react-confetti-explosion";
import { Helmet } from "react-helmet";

export default function Birthday() {
    const [countdown, setCountdown] = useState<string | null>(null);

    useEffect(() => {
        const calculateCountdown = () => {
            const birthdayString = pb.authStore.model?.birthday;
            const birthdayDate = new Date(birthdayString);
            const currentYear = new Date().getFullYear();
            let nextBirthday = new Date(currentYear, birthdayDate.getMonth(), birthdayDate.getDate());
            const currentTime = new Date();

            if (nextBirthday < currentTime) {
                nextBirthday.setFullYear(currentYear + 1);
            }

            const currentOffset = currentTime.getTimezoneOffset() * 60000; // Convert minutes to milliseconds
            const birthdayOffset = nextBirthday.getTimezoneOffset() * 60000; // Convert minutes to milliseconds

            // Adjust for the timezone offset
            nextBirthday = new Date(nextBirthday.getTime() + currentOffset - birthdayOffset);

            if (nextBirthday.getDate() === currentTime.getDate() && nextBirthday.getMonth() === currentTime.getMonth()) {
                setCountdown("Happy birthday!");
            } else {
                if (nextBirthday < currentTime) {
                    nextBirthday.setDate(nextBirthday.getDate() + 1);
                }

                const timeDiff = nextBirthday.getTime() - currentTime.getTime();
                const seconds = Math.floor((timeDiff / 1000) % 60);
                const minutes = Math.floor((timeDiff / 1000 / 60) % 60);
                const hours = Math.floor((timeDiff / (1000 * 60 * 60)) % 24);
                const days = Math.floor(timeDiff / (1000 * 60 * 60 * 24));

                setCountdown(`${days} days, ${hours} hours, ${minutes} minutes, ${seconds} seconds.`);
            }
        };

        calculateCountdown();
        const interval = setInterval(calculateCountdown, 1000);

        return () => clearInterval(interval);
    }, []);

    return (
        <>
            <Helmet>
                <title>ReinVB Studio — Birthday</title>
            </Helmet>
            <Container className="">
                <div className={`relative flex h-[92vh] w-full flex-col items-center justify-center gap-8`}>
                    {countdown !== "Happy birthday!" ? (
                        <>
                            <div className="font-outline-4 font-mono text-2xl font-black lg:text-5xl">Your birthday is in</div>
                            <div className="font-outline-4 text-center font-mono text-xl font-black lg:text-3xl">{countdown}</div>
                        </>
                    ) : (
                        <>
                            <ConfettiExplosion particleCount={200} />
                            <div className="font-outline-4 font-mono text-2xl font-black md:text-4xl lg:text-7xl">Happy Birthday! 🎉</div>
                        </>
                    )}
                </div>
            </Container>
        </>
    );
}
